import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "17", "height": "12", "viewBox": "0 0 17 12", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M6.84647 8.6421L15.4026 0.0859375L16.6666 1.34989L6.84647 11.17L0.714844 5.03838L1.9788 3.77443L6.84647 8.6421Z", "fill": "#006EFF" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const CorrectIcon = __component__.exports;
export {
  CorrectIcon as default
};
